window.locales = window.locales || {};window.locales.am = window.locales.am || {};window.locales.am.studentNetworkV2 = window.locales.am.studentNetworkV2 || {};window.locales.am.studentNetworkV2.studentNetworkV2 = window.locales.am.studentNetworkV2.studentNetworkV2 || {};window.locales.am.studentNetworkV2.studentNetworkV2 = {...window.locales.am.studentNetworkV2.studentNetworkV2, ...{
    "nav": {
        "people": "ሰዎች",
        "map": "ካርታ",
        "events": "ክስተቶች",
        "messages": "መልዕክቶች"
    },
    "profile": {
        "returnToList": "ወደ ዝርዝር ተመለስ"
    },
    "people": {
        "message": "መልዕክት",
        "loadMore": "ተጨማሪ ጫን",
        "remaining": "ቀሪ",
        "loading": "በአሁኑ ጊዜ ጫንና...",
        "noResults": "ከፍለጋዎ ጋር የሚዛመድ ውጤት አልተገኘም",
        "studentsAndAlumni": "ተማሪዎች እና ምሩቃን",
        "studentsOnly": "ተማሪዎች",
        "alumniOnly": "ምሩቃን"
    },
    "filters": {
        "search": "ፈልግ…",
        "citySearch": "ከተማ ፈልግ…",
        "programs": "ፕሮግራሞች",
        "selectPrograms": "ፕሮግራሞች ይምረጡ",
        "all": "ሁሉም",
        "students": "ተማሪዎች",
        "alumni": "የቅድመ ተማሪዎች",
        "myClass": "የኔ ክፍል",
        "showAdvancedFilters": "ከፍተኛ ማጣሪያዎችን ያሳይ",
        "quanticDegreePrograms": "የ Quantic ዲግሪ ፕሮግራሞች",
        "valarDegreePrograms": "የ Valar ዲግሪ ፕሮግራሞች",
        "execEdPrograms": "የአስፈጻሚ ትምህርት ፕሮግራሞች",
        "filtersTitle": "ማጣሪያዎች",
        "applyFilters": "ማጣሪያዎችን ይተግብሩ",
        "reset": "ማጣሪያዎችን ዳግም ያስጀምሩ"
    },
    "profileDetail": {
        "backToList": "ወደ ዝርዝር ተመለስ",
        "message": "መልዕክት",
        "interests": "ፍላጎቶች",
        "lookingFor": "ፈልጌ ያለሁ",
        "education": "ትምህርት",
        "workHistory": "የሥራ ታሪክ"
    },
    "findMore": {
        "title": "ተጨማሪ ተማሪዎችና የቅድመ ተማሪዎችን ፈልግ",
        "fromLocation": "ከዚህ ቦታ",
        "workedAtCompany": "በዚህ ኩባንያ ሰርቷል",
        "fromIndustry": "ከዚህ ኢንዱስትሪ",
        "attendedSchool": "ይህ ትምህርት ቤት ብቅ ብሏል",
        "enrolledInProgram": "በዚህ ፕሮግራም ተመዝግቧል"
    },
    "advancedFilters": {
        "companySearch": "ኩባንያ ፈልግ...",
        "industry": "ኢንዱስትሪ",
        "selectIndustry": "ኢንዱስትሪ ይምረጡ",
        "interests": "ፍላጎቶች",
        "selectInterest": "ፍላጎት ይምረጡ",
        "lookingFor": "ፈልጌ ያለሁ",
        "selectFromList": "ከዝርዝር ይምረጡ",
        "timezone": "ሰአት ዞን",
        "selectTimezones": "ሰአት ዞኖች ይምረጡ"
    },
    "eventDetail": {
        "event": "ክስተት",
        "backToEvents": "ወደ ክስተቶች ተመለስ",
        "details": "ዝርዝሮች",
        "register": "ይመዝገቡ",
        "addToCalendar": "ወደ ቀን መቁጠሪያ ያክሉ",
        "deviceCalendar": "የመሣሪያ ቀን መቁጠሪያ",
        "onlineEvent": "የመስመር ላይ ክስተት",
        "googleCalendar": "Google Calendar",
        "office365": "Office 365",
        "outlookCom": "Outlook.com",
        "downloadIcs": "አውርድ (.ics)",
        "detailsAreHidden": "ዝርዝሮች ለአሁኑ ተማሪዎች እና ለተመራቂዎች ይገኛሉ።"
    },
    "events": {
        "featured": "ተለይተው የቀረቡ",
        "upcoming": "መጪ",
        "pastEvents": "ያለፉ ክስተቶች",
        "search": "ፈልግ…",
        "recommendedEvents": "የሚመከሩ ክስተቶች",
        "allEvents": "ሁሉም ክስተቶች",
        "searchingAllEvents": "ሁሉንም ክስተቶች በመፈለግ ላይ",
        "noEvents": "ክስተቶች አልተገኙም",
        "noUpcomingEventsMatching": "ከፍለጋዎ ጋር የሚዛመድ መጪ ክስተት የለም",
        "noPastEventsMatching": "ከፍለጋዎ ጋር የሚዛመድ ያለፈ ክስተት የለም",
        "loadMore": "ተጨማሪ ጫን",
        "remaining": "ቀሪ",
        "loading": "በአሁኑ ጊዜ ጫንና...",
        "recommendedTooltip": "ከአካባቢዎ ወይም ከቡድንዎ ጋር ተዛማጅ ክስተቶች",
        "clearFilter": "ማጣሪያን ያጽዱ",
        "onlineEvents": "የመስመር ላይ ክስተቶች",
        "inPersonEvents": "በአካል የሚደረጉ ክስተቶች",
        "meetupEvents": "የስብሰባ ክስተቶች",
        "conferenceEvents": "የኮንፈረንስ ክስተቶች",
        "companyVisitEvents": "የኩባንያ ጉብኝት ክስተቶች",
        "specialEventEvents": "ልዩ ክስተቶች",
        "virtualMeetupEvents": "ምናባዊ የስብሰባ ክስተቶች",
        "careerFairEvents": "የሥራ ትርዒት ክስተቶች",
        "admissionsEventEvents": "የመግቢያ ክስተቶች",
        "bookClubEvents": "የመጽሐፍ ክበብ ክስተቶች",
        "onlineEventEvents": "ምናባዊ የስብሰባ ክስተቶች",
        "documentaryClubEvents": "የዘጋቢ ፊልም ክበብ ክስተቶች",
        "podcastClubEvents": "የፖድካስት ክበብ ክስተቶች",
        "tedTalkClubEvents": "የ TEDTalk ክበብ ክስተቶች",
        "studentOrganizationEventsEvents": "የተማሪ ድርጅት ክስተቶች",
        "askMeAnythingEvents": "ማንኛውንም ይጠይቁኝ ክስተቶች",
        "officeHoursEvents": "የቢሮ ሰዓት ክስተቶች",
        "academicWebinarEvents": "የአካዳሚክ ዌብናር ክስተቶች"
    },
    "contactForm": {
        "title": "ለ {name} መልዕክት",
        "defaultSubject": "{brand} - ከ {name} መልዕክት",
        "subject": "ርዕስ",
        "replyTo": "መልስ ለ",
        "message": "መልዕክት",
        "placeholder": "መልዕክትዎን ይጻፉ...",
        "send": "መልዕክት ላክ",
        "sending": "በመላክ ላይ...",
        "messageSent": "መልዕክት ተልኳል!"
    },
    "cluster": {
        "studentsInArea": "በዚህ ቦታ ያሉ ተማሪዎች",
        "backToMap": "ወደ ካርታ ተመለስ"
    },
    "partialAccessModal": {
        "explain": "የ {brandName} ኔትወርክ ለተማሪዎች እና ለምሩቃን የተዘጋጀ ልዩ ዓለም አቀፍ ማህበረሰብ ነው።",
        "instructions": "ይህንን ውሱን ባህሪ ቅድመ-እይታ ለመመርመር ካርታውን እና ማጣሪያዎቹን ይጠቀሙ።",
        "deadline": "ቀጣይ የማመልከቻ ግዜ:",
        "registrationDeadline": "የምዝገባ ግዜ:",
        "applyNow": "አሁን ያመልክቱ",
        "registerNow": "አሁን ይመዝገቡ",
        "explore": "ያስሱ"
    },
    "onboardingWizard": {
        "stepOneTitle": "ወደ ኔትወርክ እንኳን በደህና መጡ",
        "stepOneMessage": "የ {brandName} ልዩ ዓለም አቀፍ ኔትወርክን ያግኙ። ካርታውን እና ማጣሪያዎቹን ይጠቀሙ።",
        "stepTwoTitle": "ማህበረሰቡን ይዳስሱ",
        "stepTwoMessage": "ክበቦቹ የተማሪዎችን እና የምሩቃንን ስብስብ ይወክላሉ። በዚያ ክልል ያሉ መገለጫዎችን ለመመልከት ይጫኑ።",
        "stepThreeTitle": "በልበ ሙሉነት ይገናኙ",
        "stepThreeMessage": "ለባልደረቦችዎ መልዕክት በመላክ ትርጉም ያላቸው ግንኙነቶችን ይፍጠሩ።",
        "stepFourTitle": "አነቃቂ ክስተቶችን ያግኙ",
        "stepFourMessage": "በመስመር ላይ እና በዓለም ዙሪያ የሚዘጋጁ ልዩ የቀጥታ ክስተቶቻችንን ያስሱ።",
        "anonymous": "ስም-አልባ",
        "hidden": "የተደበቀ",
        "activationTitle": "መገለጫዎን ያግብሩ",
        "activationMessageBefore": "የተማሪ ኔትወርክ መገለጫዎ በአሁኑ ጊዜ ",
        "activationMessageAfter": " ተብሎ ተቀምጧል። መገለጫዎን ለባልደረቦችዎ ለማሳየት ይፈልጋሉ?",
        "changeSettingSmallprint": "ይህንን ምርጫ በማንኛውም ጊዜ በኔትወርክ ቅንብሮች ውስጥ መቀየር ይችላሉ።",
        "emailTitle": "የሚመረጥ የመገናኛ ኢሜይል",
        "emailMessage": "አንድ ነገር ብቻ ቀረ – ከተማሪዎች እና ከምሩቃን መልዕክቶች ለመቀበል የሚፈልጉትን ኢሜይል አድራሻ ያረጋግጡ!",
        "emailAddress": "ኢሜይል አድራሻ",
        "next": "ቀጣይ",
        "getStarted": "ጀምር",
        "activateMyProfile": "አዎ! መገለጫዬን አግብር",
        "staySetting": "አይ፣ {setting} ይቆይ",
        "completeSetup": "ማዋቀሩን አጠናቅ"
    },
    "errors": {
        "requestFailed": "ጥያቄው አልተሳካም። እባክዎ ግንኙነትዎን ያረጋግጡ እና እንደገና ይሞክሩ።",
        "somethingWentWrong": "የሆነ ችግር ተፈጥሯል። እባክዎ እንደገና ይሞክሩ።",
        "retry": "እንደገና ሞክር",
        "loadMoreFailed": "ተጨማሪ መጫን አልተሳካም። ለመሞከር ይንኩ።",
        "locationPermissionDeniedTitle": "የአካባቢ ፈቃድ ጠፍቷል",
        "locationPermissionDeniedBody": "በመሣሪያዎ ቅንብሮች ውስጥ የአካባቢ መዳረሻን ይፍቀዱ።",
        "locationServicesDisabledTitle": "የአካባቢ አገልግሎቶች ጠፍተዋል",
        "locationServicesDisabledBody": "በመሣሪያዎ ቅንብሮች ውስጥ የአካባቢ አገልግሎቶችን ያብሩ።",
        "locationUnavailableTitle": "አካባቢዎን ማግኘት አልተቻለም",
        "locationUnavailableBody": "እባክዎ እንደገና ይሞክሩ።"
    }
}
};window.locales.ar = window.locales.ar || {};window.locales.ar.studentNetworkV2 = window.locales.ar.studentNetworkV2 || {};window.locales.ar.studentNetworkV2.studentNetworkV2 = window.locales.ar.studentNetworkV2.studentNetworkV2 || {};window.locales.ar.studentNetworkV2.studentNetworkV2 = {...window.locales.ar.studentNetworkV2.studentNetworkV2, ...{
    "nav": {
        "people": "الأشخاص",
        "map": "الخريطة",
        "events": "الأحداث",
        "messages": "الرسائل"
    },
    "profile": {
        "returnToList": "العودة إلى القائمة"
    },
    "people": {
        "message": "رسالة",
        "loadMore": "تحميل المزيد",
        "remaining": "متبقي",
        "loading": "جاري التحميل...",
        "noResults": "لم تتطابق أي نتائج مع بحثك",
        "studentsAndAlumni": "طلاب وخريجون",
        "studentsOnly": "طلاب",
        "alumniOnly": "خريجون"
    },
    "filters": {
        "search": "بحث…",
        "citySearch": "بحث المدينة…",
        "programs": "البرامج",
        "selectPrograms": "اختر البرامج",
        "all": "الكل",
        "students": "الطلاب",
        "alumni": "الخريجون",
        "myClass": "فصلي",
        "showAdvancedFilters": "إظهار المرشحات المتقدمة",
        "quanticDegreePrograms": "برامج درجات Quantic",
        "valarDegreePrograms": "برامج درجات Valar",
        "execEdPrograms": "برامج التعليم التنفيذي",
        "filtersTitle": "المرشحات",
        "applyFilters": "تطبيق المرشحات",
        "reset": "إعادة تعيين المرشحات"
    },
    "profileDetail": {
        "backToList": "العودة إلى القائمة",
        "message": "رسالة",
        "interests": "الاهتمامات",
        "lookingFor": "يبحث عن",
        "education": "التعليم",
        "workHistory": "سجل العمل"
    },
    "findMore": {
        "title": "البحث عن المزيد من الطلاب والخريجين",
        "fromLocation": "من هذا الموقع",
        "workedAtCompany": "عمل في هذه الشركة",
        "fromIndustry": "من هذه الصناعة",
        "attendedSchool": "حضر هذه المدرسة",
        "enrolledInProgram": "الملتحق بهذا البرنامج"
    },
    "advancedFilters": {
        "companySearch": "بحث الشركة...",
        "industry": "الصناعة",
        "selectIndustry": "اختر الصناعة",
        "interests": "الاهتمامات",
        "selectInterest": "اختر الاهتمام",
        "lookingFor": "يبحث عن",
        "selectFromList": "اختر من القائمة",
        "timezone": "المنطقة الزمنية",
        "selectTimezones": "اختر المناطق الزمنية"
    },
    "eventDetail": {
        "event": "حدث",
        "backToEvents": "العودة إلى الأحداث",
        "details": "التفاصيل",
        "register": "تسجيل",
        "addToCalendar": "إضافة إلى التقويم",
        "deviceCalendar": "تقويم الجهاز",
        "onlineEvent": "حدث عبر الإنترنت",
        "googleCalendar": "Google Calendar",
        "office365": "Office 365",
        "outlookCom": "Outlook.com",
        "downloadIcs": "تحميل (.ics)",
        "detailsAreHidden": "التفاصيل متاحة للطلاب الحاليين والخريجين."
    },
    "events": {
        "featured": "مميزة",
        "upcoming": "القادمة",
        "pastEvents": "أحداث سابقة",
        "search": "بحث…",
        "recommendedEvents": "أحداث موصى بها",
        "allEvents": "جميع الأحداث",
        "searchingAllEvents": "البحث في جميع الأحداث",
        "noEvents": "لم يتم العثور على أحداث",
        "noUpcomingEventsMatching": "لا توجد أحداث قادمة تطابق بحثك",
        "noPastEventsMatching": "لا توجد أحداث سابقة تطابق بحثك",
        "loadMore": "تحميل المزيد",
        "remaining": "متبقي",
        "loading": "جاري التحميل...",
        "recommendedTooltip": "أحداث ذات صلة بموقعك أو مجموعتك",
        "clearFilter": "مسح المرشح",
        "onlineEvents": "أحداث عبر الإنترنت",
        "inPersonEvents": "أحداث حضورية",
        "meetupEvents": "لقاءات",
        "conferenceEvents": "مؤتمرات",
        "companyVisitEvents": "زيارات الشركات",
        "specialEventEvents": "أحداث خاصة",
        "virtualMeetupEvents": "لقاءات افتراضية",
        "careerFairEvents": "معارض التوظيف",
        "admissionsEventEvents": "أحداث القبول",
        "bookClubEvents": "نادي الكتاب",
        "onlineEventEvents": "لقاءات افتراضية",
        "documentaryClubEvents": "نادي الأفلام الوثائقية",
        "podcastClubEvents": "نادي البودكاست",
        "tedTalkClubEvents": "نادي TEDTalk",
        "studentOrganizationEventsEvents": "أحداث المنظمات الطلابية",
        "askMeAnythingEvents": "جلسات اسألني أي شيء",
        "officeHoursEvents": "ساعات المكتب",
        "academicWebinarEvents": "ندوات أكاديمية عبر الإنترنت"
    },
    "contactForm": {
        "title": "رسالة إلى {name}",
        "defaultSubject": "{brand} - رسالة من {name}",
        "subject": "الموضوع",
        "replyTo": "الرد على",
        "message": "الرسالة",
        "placeholder": "اكتب رسالتك...",
        "send": "إرسال الرسالة",
        "sending": "جاري الإرسال...",
        "messageSent": "تم إرسال الرسالة!"
    },
    "cluster": {
        "studentsInArea": "طلاب في هذا الموقع",
        "backToMap": "العودة إلى الخريطة"
    },
    "partialAccessModal": {
        "explain": "شبكة {brandName} هي مجتمع عالمي حصري للطلاب والخريجين.",
        "instructions": "استخدم الخريطة والمرشحات لاستكشاف هذه المعاينة المحدودة الميزات.",
        "deadline": "الموعد النهائي القادم للتقديم:",
        "registrationDeadline": "الموعد النهائي للتسجيل:",
        "applyNow": "قدّم الآن",
        "registerNow": "سجّل الآن",
        "explore": "استكشف"
    },
    "onboardingWizard": {
        "stepOneTitle": "مرحباً بك في الشبكة",
        "stepOneMessage": "اكتشف شبكة {brandName} العالمية الحصرية. استخدم الخريطة والمرشحات للاستكشاف.",
        "stepTwoTitle": "تنقّل في المجتمع",
        "stepTwoMessage": "تمثل الدوائر مجموعات من الطلاب والخريجين. انقر لعرض الملفات الشخصية في تلك المنطقة.",
        "stepThreeTitle": "تواصل بثقة",
        "stepThreeMessage": "أنشئ روابط ذات معنى عبر مراسلة زملائك.",
        "stepFourTitle": "اكتشف أحداثاً ملهمة",
        "stepFourMessage": "تصفّح أحداثنا الحصرية المباشرة، المنظمة عبر الإنترنت وحول العالم.",
        "anonymous": "مجهول",
        "hidden": "مخفي",
        "activationTitle": "فعّل ملفك الشخصي",
        "activationMessageBefore": "ملفك الشخصي في شبكة الطلاب مُعيّن حالياً كـ ",
        "activationMessageAfter": ". هل تود جعل ملفك الشخصي مرئياً لزملائك؟",
        "changeSettingSmallprint": "يمكنك تغيير هذا التفضيل في أي وقت في إعدادات الشبكة.",
        "emailTitle": "البريد الإلكتروني المفضل للتواصل",
        "emailMessage": "شيء أخير – يرجى تأكيد عنوان البريد الإلكتروني الذي تود تلقي رسائل الطلاب والخريجين عليه!",
        "emailAddress": "عنوان البريد الإلكتروني",
        "next": "التالي",
        "getStarted": "ابدأ",
        "activateMyProfile": "نعم! فعّل ملفي الشخصي",
        "staySetting": "لا، ابقَ {setting}",
        "completeSetup": "إكمال الإعداد"
    },
    "errors": {
        "requestFailed": "فشل الطلب. يرجى التحقق من اتصالك والمحاولة مرة أخرى.",
        "somethingWentWrong": "حدث خطأ ما. يرجى المحاولة مرة أخرى.",
        "retry": "إعادة المحاولة",
        "loadMoreFailed": "فشل تحميل المزيد. انقر لإعادة المحاولة.",
        "locationPermissionDeniedTitle": "إذن الموقع مُعطَّل",
        "locationPermissionDeniedBody": "اسمح بالوصول إلى الموقع في إعدادات جهازك.",
        "locationServicesDisabledTitle": "خدمات الموقع مُعطَّلة",
        "locationServicesDisabledBody": "قم بتشغيل خدمات الموقع في إعدادات جهازك.",
        "locationUnavailableTitle": "لم نتمكن من تحديد موقعك",
        "locationUnavailableBody": "يرجى المحاولة مرة أخرى."
    }
}
};window.locales.en = window.locales.en || {};window.locales.en.studentNetworkV2 = window.locales.en.studentNetworkV2 || {};window.locales.en.studentNetworkV2.studentNetworkV2 = window.locales.en.studentNetworkV2.studentNetworkV2 || {};window.locales.en.studentNetworkV2.studentNetworkV2 = {...window.locales.en.studentNetworkV2.studentNetworkV2, ...{
    "nav": {
        "people": "People",
        "map": "Map",
        "events": "Events",
        "messages": "Messages"
    },
    "profile": {
        "returnToList": "Return to List"
    },
    "people": {
        "message": "Message",
        "loadMore": "Load more",
        "remaining": "remaining",
        "loading": "Loading...",
        "noResults": "No results matched your search",
        "studentsAndAlumni": "students and alumni",
        "studentsOnly": "students",
        "alumniOnly": "alumni"
    },
    "filters": {
        "search": "Search…",
        "citySearch": "City search…",
        "programs": "Programs",
        "selectPrograms": "All programs",
        "all": "All",
        "students": "Students",
        "alumni": "Alumni",
        "myClass": "My Class",
        "showAdvancedFilters": "Show Advanced Filters",
        "quanticDegreePrograms": "Quantic Degree Programs",
        "valarDegreePrograms": "Valar Degree Programs",
        "execEdPrograms": "Executive Education Programs",
        "filtersTitle": "FILTERS",
        "applyFilters": "Apply Filters",
        "reset": "Reset Filters"
    },
    "profileDetail": {
        "backToList": "Return to People",
        "message": "Message",
        "interests": "Interests",
        "lookingFor": "Looking For",
        "education": "Education",
        "workHistory": "Work History"
    },
    "findMore": {
        "title": "Find More Students & Alumni",
        "fromLocation": "From this location",
        "workedAtCompany": "Worked at this company",
        "fromIndustry": "From this industry",
        "attendedSchool": "Attended this school",
        "enrolledInProgram": "Enrolled in this program"
    },
    "advancedFilters": {
        "companySearch": "Company search...",
        "industry": "Industry",
        "selectIndustry": "Select industry",
        "interests": "Interests",
        "selectInterest": "Select interest",
        "lookingFor": "Looking For",
        "selectFromList": "Select from list",
        "timezone": "Timezone",
        "selectTimezones": "Select timezones"
    },
    "eventDetail": {
        "event": "Event",
        "backToEvents": "Back to Events",
        "details": "Details",
        "detailsAreHidden": "Details are available to current students and alumni.",
        "register": "Register",
        "addToCalendar": "Add to Calendar",
        "deviceCalendar": "Device Calendar",
        "onlineEvent": "Online Event",
        "googleCalendar": "Google Calendar",
        "office365": "Office 365",
        "outlookCom": "Outlook.com",
        "downloadIcs": "Download (.ics)"
    },
    "events": {
        "featured": "Featured",
        "upcoming": "Upcoming",
        "pastEvents": "Past Events",
        "search": "Search…",
        "recommendedEvents": "Recommended Events",
        "allEvents": "All Events",
        "searchingAllEvents": "Searching All Events",
        "noEvents": "No events found",
        "noUpcomingEventsMatching": "No upcoming events match your search",
        "noPastEventsMatching": "No past events match your search",
        "loadMore": "Load more",
        "remaining": "remaining",
        "loading": "Loading...",
        "recommendedTooltip": "Events that are relevant to your location or cohort",
        "clearFilter": "Clear Filter",
        "onlineEvents": "Online Events",
        "inPersonEvents": "In-Person Events",
        "meetupEvents": "Meetup Events",
        "conferenceEvents": "Conference Events",
        "companyVisitEvents": "Business Visit Events",
        "specialEventEvents": "Special Events",
        "virtualMeetupEvents": "Virtual Meetup Events",
        "careerFairEvents": "Career Fair Events",
        "admissionsEventEvents": "Admissions Events",
        "bookClubEvents": "Book Club Events",
        "onlineEventEvents": "Virtual Meetup Events",
        "documentaryClubEvents": "Documentary Club Events",
        "podcastClubEvents": "Podcast Club Events",
        "tedTalkClubEvents": "TEDTalk Club Events",
        "studentOrganizationEventsEvents": "Student Organization Events",
        "askMeAnythingEvents": "Ask Me Anything Events",
        "officeHoursEvents": "Office Hours Events",
        "academicWebinarEvents": "Academic Webinar Events"
    },
    "contactForm": {
        "title": "Message {name}",
        "defaultSubject": "{brand} - Message from {name}",
        "subject": "Subject",
        "replyTo": "Reply To",
        "message": "Message",
        "placeholder": "Write your message...",
        "send": "Send Message",
        "sending": "Sending...",
        "messageSent": "Message sent!"
    },
    "cluster": {
        "studentsInArea": "Students at This Location",
        "backToMap": "Back to Map"
    },
    "partialAccessModal": {
        "explain": "The {brandName} Network is an exclusive global community for students and alumni.",
        "instructions": "Use the map and filters to explore this feature-limited preview.",
        "deadline": "Next application deadline:",
        "registrationDeadline": "Registration deadline:",
        "applyNow": "Apply Now",
        "registerNow": "Register Now",
        "explore": "Explore"
    },
    "onboardingWizard": {
        "stepOneTitle": "Welcome to the Network",
        "stepOneMessage": "Discover {brandName}'s exclusive global network. Use the map and filters to explore.",
        "stepTwoTitle": "Navigate the Community",
        "stepTwoMessage": "Circles represent clusters of students and alumni. Click to view profiles in that region.",
        "stepThreeTitle": "Connect with Confidence",
        "stepThreeMessage": "Make meaningful connections by messaging classmates.",
        "stepFourTitle": "Discover Inspiring Events",
        "stepFourMessage": "Browse our exclusive, live events, hosted online and around the world.",
        "anonymous": "anonymous",
        "hidden": "hidden",
        "activationTitle": "Activate your Profile",
        "activationMessageBefore": "Your student network profile is currently set to ",
        "activationMessageAfter": ". Would you like to make your profile visible to your peers?",
        "changeSettingSmallprint": "You can change this preference at any time in network settings.",
        "emailTitle": "Preferred Contact Email",
        "emailMessage": "Just one more thing \u2013 please confirm the email address you'd like to receive messages from students and alumni!",
        "emailAddress": "Email Address",
        "next": "Next",
        "getStarted": "Get Started",
        "activateMyProfile": "Yes! Activate my profile",
        "staySetting": "No, stay {setting}",
        "completeSetup": "Complete Setup"
    },
    "errors": {
        "requestFailed": "A request failed. Please check your connection and try again.",
        "somethingWentWrong": "Something went wrong. Please try again.",
        "retry": "Retry",
        "loadMoreFailed": "Failed to load more. Tap to retry.",
        "locationPermissionDeniedTitle": "Location permission is off",
        "locationPermissionDeniedBody": "Enable location access in your device settings.",
        "locationServicesDisabledTitle": "Location Services are off",
        "locationServicesDisabledBody": "Turn on Location Services in your device settings.",
        "locationUnavailableTitle": "Couldn't find your location",
        "locationUnavailableBody": "Please try again."
    }
}
};window.locales.es = window.locales.es || {};window.locales.es.studentNetworkV2 = window.locales.es.studentNetworkV2 || {};window.locales.es.studentNetworkV2.studentNetworkV2 = window.locales.es.studentNetworkV2.studentNetworkV2 || {};window.locales.es.studentNetworkV2.studentNetworkV2 = {...window.locales.es.studentNetworkV2.studentNetworkV2, ...{
    "nav": {
        "people": "Personas",
        "map": "Mapa",
        "events": "Eventos",
        "messages": "Mensajes"
    },
    "profile": {
        "returnToList": "Volver a la lista"
    },
    "people": {
        "message": "Mensaje",
        "loadMore": "Cargar más",
        "remaining": "restantes",
        "loading": "Cargando...",
        "noResults": "No se encontraron resultados para tu búsqueda",
        "studentsAndAlumni": "estudiantes y egresados",
        "studentsOnly": "estudiantes",
        "alumniOnly": "egresados"
    },
    "filters": {
        "search": "Buscar…",
        "citySearch": "Buscar ciudad…",
        "programs": "Programas",
        "selectPrograms": "Seleccionar programas",
        "all": "Todos",
        "students": "Estudiantes",
        "alumni": "Egresados",
        "myClass": "Mi clase",
        "showAdvancedFilters": "Mostrar filtros avanzados",
        "quanticDegreePrograms": "Programas de grado Quantic",
        "valarDegreePrograms": "Programas de grado Valar",
        "execEdPrograms": "Programas de educación ejecutiva",
        "filtersTitle": "FILTROS",
        "applyFilters": "Aplicar filtros",
        "reset": "Restablecer filtros"
    },
    "profileDetail": {
        "backToList": "Volver a la lista",
        "message": "Mensaje",
        "interests": "Intereses",
        "lookingFor": "Buscando",
        "education": "Educación",
        "workHistory": "Experiencia laboral"
    },
    "findMore": {
        "title": "Encontrar más estudiantes y egresados",
        "fromLocation": "De esta ubicación",
        "workedAtCompany": "Trabajó en esta empresa",
        "fromIndustry": "De esta industria",
        "attendedSchool": "Asistió a esta escuela",
        "enrolledInProgram": "Inscrito en este programa"
    },
    "advancedFilters": {
        "companySearch": "Buscar empresa...",
        "industry": "Industria",
        "selectIndustry": "Seleccionar industria",
        "interests": "Intereses",
        "selectInterest": "Seleccionar interés",
        "lookingFor": "Buscando",
        "selectFromList": "Seleccionar de la lista",
        "timezone": "Zona horaria",
        "selectTimezones": "Seleccionar zonas horarias"
    },
    "eventDetail": {
        "event": "Evento",
        "backToEvents": "Volver a eventos",
        "details": "Detalles",
        "register": "Registrarse",
        "addToCalendar": "Añadir al calendario",
        "deviceCalendar": "Calendario del dispositivo",
        "onlineEvent": "Evento en línea",
        "googleCalendar": "Google Calendar",
        "office365": "Office 365",
        "outlookCom": "Outlook.com",
        "downloadIcs": "Descargar (.ics)",
        "detailsAreHidden": "Los detalles están disponibles para estudiantes actuales y exalumnos."
    },
    "events": {
        "featured": "Destacados",
        "upcoming": "Próximos",
        "pastEvents": "Eventos pasados",
        "search": "Buscar…",
        "recommendedEvents": "Eventos recomendados",
        "allEvents": "Todos los eventos",
        "searchingAllEvents": "Buscando en todos los eventos",
        "noEvents": "No se encontraron eventos",
        "noUpcomingEventsMatching": "No hay eventos próximos que coincidan con tu búsqueda",
        "noPastEventsMatching": "No hay eventos pasados que coincidan con tu búsqueda",
        "loadMore": "Cargar más",
        "remaining": "restantes",
        "loading": "Cargando...",
        "recommendedTooltip": "Eventos relevantes para tu ubicación o cohorte",
        "clearFilter": "Borrar filtro",
        "onlineEvents": "Eventos en línea",
        "inPersonEvents": "Eventos presenciales",
        "meetupEvents": "Encuentros",
        "conferenceEvents": "Conferencias",
        "companyVisitEvents": "Visitas empresariales",
        "specialEventEvents": "Eventos especiales",
        "virtualMeetupEvents": "Encuentros virtuales",
        "careerFairEvents": "Ferias de empleo",
        "admissionsEventEvents": "Eventos de admisión",
        "bookClubEvents": "Club de lectura",
        "onlineEventEvents": "Encuentros virtuales",
        "documentaryClubEvents": "Club de documentales",
        "podcastClubEvents": "Club de podcasts",
        "tedTalkClubEvents": "Club de TEDTalks",
        "studentOrganizationEventsEvents": "Eventos de organizaciones estudiantiles",
        "askMeAnythingEvents": "Sesiones de preguntas abiertas",
        "officeHoursEvents": "Horario de oficina",
        "academicWebinarEvents": "Seminarios web académicos"
    },
    "contactForm": {
        "title": "Mensaje para {name}",
        "defaultSubject": "{brand} - Mensaje de {name}",
        "subject": "Asunto",
        "replyTo": "Responder a",
        "message": "Mensaje",
        "placeholder": "Escribe tu mensaje...",
        "send": "Enviar mensaje",
        "sending": "Enviando...",
        "messageSent": "¡Mensaje enviado!"
    },
    "cluster": {
        "studentsInArea": "Estudiantes en esta ubicación",
        "backToMap": "Volver al mapa"
    },
    "partialAccessModal": {
        "explain": "La red de {brandName} es una comunidad global exclusiva para estudiantes y egresados.",
        "instructions": "Usa el mapa y los filtros para explorar esta vista previa con funciones limitadas.",
        "deadline": "Próxima fecha límite de solicitud:",
        "registrationDeadline": "Fecha límite de inscripción:",
        "applyNow": "Solicitar ahora",
        "registerNow": "Inscribirse ahora",
        "explore": "Explorar"
    },
    "onboardingWizard": {
        "stepOneTitle": "Bienvenido a la Red",
        "stepOneMessage": "Descubre la red global exclusiva de {brandName}. Usa el mapa y los filtros para explorar.",
        "stepTwoTitle": "Navega por la comunidad",
        "stepTwoMessage": "Los círculos representan grupos de estudiantes y egresados. Haz clic para ver perfiles en esa región.",
        "stepThreeTitle": "Conecta con confianza",
        "stepThreeMessage": "Establece conexiones significativas enviando mensajes a tus compañeros.",
        "stepFourTitle": "Descubre eventos inspiradores",
        "stepFourMessage": "Explora nuestros eventos exclusivos en vivo, organizados en línea y alrededor del mundo.",
        "anonymous": "anónimo",
        "hidden": "oculto",
        "activationTitle": "Activa tu perfil",
        "activationMessageBefore": "Tu perfil en la red estudiantil está actualmente configurado como ",
        "activationMessageAfter": ". ¿Te gustaría hacer visible tu perfil para tus compañeros?",
        "changeSettingSmallprint": "Puedes cambiar esta preferencia en cualquier momento en configuración de red.",
        "emailTitle": "Correo electrónico de contacto preferido",
        "emailMessage": "Solo una cosa más: ¡confirma la dirección de correo electrónico en la que deseas recibir mensajes de estudiantes y egresados!",
        "emailAddress": "Dirección de correo electrónico",
        "next": "Siguiente",
        "getStarted": "Comenzar",
        "activateMyProfile": "¡Sí! Activar mi perfil",
        "staySetting": "No, mantener {setting}",
        "completeSetup": "Completar configuración"
    },
    "errors": {
        "requestFailed": "Una solicitud falló. Verifica tu conexión e intenta de nuevo.",
        "somethingWentWrong": "Algo salió mal. Inténtalo de nuevo.",
        "retry": "Reintentar",
        "loadMoreFailed": "Error al cargar más. Toca para reintentar.",
        "locationPermissionDeniedTitle": "El permiso de ubicación está desactivado",
        "locationPermissionDeniedBody": "Permite el acceso a la ubicación en la configuración de tu dispositivo.",
        "locationServicesDisabledTitle": "Los Servicios de ubicación están desactivados",
        "locationServicesDisabledBody": "Activa los Servicios de ubicación en la configuración de tu dispositivo.",
        "locationUnavailableTitle": "No se pudo encontrar tu ubicación",
        "locationUnavailableBody": "Inténtalo de nuevo."
    }
}
};window.locales.it = window.locales.it || {};window.locales.it.studentNetworkV2 = window.locales.it.studentNetworkV2 || {};window.locales.it.studentNetworkV2.studentNetworkV2 = window.locales.it.studentNetworkV2.studentNetworkV2 || {};window.locales.it.studentNetworkV2.studentNetworkV2 = {...window.locales.it.studentNetworkV2.studentNetworkV2, ...{
    "nav": {
        "people": "Persone",
        "map": "Mappa",
        "events": "Eventi",
        "messages": "Messaggi"
    },
    "profile": {
        "returnToList": "Torna all'elenco"
    },
    "people": {
        "message": "Messaggio",
        "loadMore": "Carica di più",
        "remaining": "rimanenti",
        "loading": "Caricamento in corso...",
        "noResults": "Nessun risultato corrispondente alla tua ricerca",
        "studentsAndAlumni": "studenti e alumni",
        "studentsOnly": "studenti",
        "alumniOnly": "alumni"
    },
    "filters": {
        "search": "Cerca…",
        "citySearch": "Cerca città…",
        "programs": "Programmi",
        "selectPrograms": "Seleziona programmi",
        "all": "Tutti",
        "students": "Studenti",
        "alumni": "Alumni",
        "myClass": "La mia classe",
        "showAdvancedFilters": "Mostra filtri avanzati",
        "quanticDegreePrograms": "Programmi di laurea Quantic",
        "valarDegreePrograms": "Programmi di laurea Valar",
        "execEdPrograms": "Programmi di formazione dirigenziale",
        "filtersTitle": "FILTRI",
        "applyFilters": "Applica filtri",
        "reset": "Reimposta filtri"
    },
    "profileDetail": {
        "backToList": "Torna all'elenco",
        "message": "Messaggio",
        "interests": "Interessi",
        "lookingFor": "Alla ricerca di",
        "education": "Istruzione",
        "workHistory": "Cronologia lavorativa"
    },
    "findMore": {
        "title": "Trova altri studenti e alumni",
        "fromLocation": "Da questa posizione",
        "workedAtCompany": "Ha lavorato presso questa azienda",
        "fromIndustry": "Da questo settore",
        "attendedSchool": "Ha frequentato questa scuola",
        "enrolledInProgram": "Iscritto a questo programma"
    },
    "advancedFilters": {
        "companySearch": "Cerca azienda...",
        "industry": "Industria",
        "selectIndustry": "Seleziona industria",
        "interests": "Interessi",
        "selectInterest": "Seleziona interesse",
        "lookingFor": "Alla ricerca di",
        "selectFromList": "Seleziona dall'elenco",
        "timezone": "Fuso orario",
        "selectTimezones": "Seleziona fusi orari"
    },
    "eventDetail": {
        "event": "Evento",
        "backToEvents": "Torna agli eventi",
        "details": "Dettagli",
        "register": "Registrati",
        "addToCalendar": "Aggiungi al calendario",
        "deviceCalendar": "Calendario del dispositivo",
        "onlineEvent": "Evento online",
        "googleCalendar": "Google Calendar",
        "office365": "Office 365",
        "outlookCom": "Outlook.com",
        "downloadIcs": "Scarica (.ics)",
        "detailsAreHidden": "I dettagli sono disponibili per studenti attuali e alumni."
    },
    "events": {
        "featured": "In evidenza",
        "upcoming": "Prossimi",
        "pastEvents": "Eventi passati",
        "search": "Cerca…",
        "recommendedEvents": "Eventi consigliati",
        "allEvents": "Tutti gli eventi",
        "searchingAllEvents": "Ricerca in tutti gli eventi",
        "noEvents": "Nessun evento trovato",
        "noUpcomingEventsMatching": "Nessun evento in programma corrisponde alla tua ricerca",
        "noPastEventsMatching": "Nessun evento passato corrisponde alla tua ricerca",
        "loadMore": "Carica di più",
        "remaining": "rimanenti",
        "loading": "Caricamento in corso...",
        "recommendedTooltip": "Eventi rilevanti per la tua posizione o coorte",
        "clearFilter": "Cancella filtro",
        "onlineEvents": "Eventi online",
        "inPersonEvents": "Eventi in presenza",
        "meetupEvents": "Incontri",
        "conferenceEvents": "Conferenze",
        "companyVisitEvents": "Visite aziendali",
        "specialEventEvents": "Eventi speciali",
        "virtualMeetupEvents": "Incontri virtuali",
        "careerFairEvents": "Fiere del lavoro",
        "admissionsEventEvents": "Eventi di ammissione",
        "bookClubEvents": "Club del libro",
        "onlineEventEvents": "Incontri virtuali",
        "documentaryClubEvents": "Club dei documentari",
        "podcastClubEvents": "Club dei podcast",
        "tedTalkClubEvents": "Club TEDTalk",
        "studentOrganizationEventsEvents": "Eventi delle organizzazioni studentesche",
        "askMeAnythingEvents": "Sessioni di domande aperte",
        "officeHoursEvents": "Orari di ricevimento",
        "academicWebinarEvents": "Webinar accademici"
    },
    "contactForm": {
        "title": "Messaggio per {name}",
        "defaultSubject": "{brand} - Messaggio da {name}",
        "subject": "Oggetto",
        "replyTo": "Rispondi a",
        "message": "Messaggio",
        "placeholder": "Scrivi il tuo messaggio...",
        "send": "Invia messaggio",
        "sending": "Invio in corso...",
        "messageSent": "Messaggio inviato!"
    },
    "cluster": {
        "studentsInArea": "Studenti in questa posizione",
        "backToMap": "Torna alla mappa"
    },
    "partialAccessModal": {
        "explain": "La rete di {brandName} è una comunità globale esclusiva per studenti e alumni.",
        "instructions": "Usa la mappa e i filtri per esplorare questa anteprima con funzionalità limitate.",
        "deadline": "Prossima scadenza per la candidatura:",
        "registrationDeadline": "Scadenza per l'iscrizione:",
        "applyNow": "Candidati ora",
        "registerNow": "Iscriviti ora",
        "explore": "Esplora"
    },
    "onboardingWizard": {
        "stepOneTitle": "Benvenuto nella Rete",
        "stepOneMessage": "Scopri la rete globale esclusiva di {brandName}. Usa la mappa e i filtri per esplorare.",
        "stepTwoTitle": "Naviga nella comunità",
        "stepTwoMessage": "I cerchi rappresentano gruppi di studenti e alumni. Clicca per visualizzare i profili in quella regione.",
        "stepThreeTitle": "Connettiti con fiducia",
        "stepThreeMessage": "Crea connessioni significative inviando messaggi ai tuoi compagni.",
        "stepFourTitle": "Scopri eventi ispiranti",
        "stepFourMessage": "Esplora i nostri eventi esclusivi dal vivo, organizzati online e in tutto il mondo.",
        "anonymous": "anonimo",
        "hidden": "nascosto",
        "activationTitle": "Attiva il tuo profilo",
        "activationMessageBefore": "Il tuo profilo nella rete studentesca è attualmente impostato come ",
        "activationMessageAfter": ". Vuoi rendere il tuo profilo visibile ai tuoi compagni?",
        "changeSettingSmallprint": "Puoi modificare questa preferenza in qualsiasi momento nelle impostazioni della rete.",
        "emailTitle": "Email di contatto preferita",
        "emailMessage": "Un'ultima cosa: conferma l'indirizzo email su cui desideri ricevere messaggi da studenti e alumni!",
        "emailAddress": "Indirizzo email",
        "next": "Avanti",
        "getStarted": "Inizia",
        "activateMyProfile": "Sì! Attiva il mio profilo",
        "staySetting": "No, mantieni {setting}",
        "completeSetup": "Completa configurazione"
    },
    "errors": {
        "requestFailed": "Una richiesta non è riuscita. Controlla la connessione e riprova.",
        "somethingWentWrong": "Qualcosa è andato storto. Riprova.",
        "retry": "Riprova",
        "loadMoreFailed": "Impossibile caricare altro. Tocca per riprovare.",
        "locationPermissionDeniedTitle": "L'autorizzazione alla posizione è disattivata",
        "locationPermissionDeniedBody": "Consenti l'accesso alla posizione nelle impostazioni del dispositivo.",
        "locationServicesDisabledTitle": "I Servizi di localizzazione sono disattivati",
        "locationServicesDisabledBody": "Attiva i Servizi di localizzazione nelle impostazioni del dispositivo.",
        "locationUnavailableTitle": "Impossibile trovare la tua posizione",
        "locationUnavailableBody": "Riprova."
    }
}
};window.locales.zh = window.locales.zh || {};window.locales.zh.studentNetworkV2 = window.locales.zh.studentNetworkV2 || {};window.locales.zh.studentNetworkV2.studentNetworkV2 = window.locales.zh.studentNetworkV2.studentNetworkV2 || {};window.locales.zh.studentNetworkV2.studentNetworkV2 = {...window.locales.zh.studentNetworkV2.studentNetworkV2, ...{
    "nav": {
        "people": "人员",
        "map": "地图",
        "events": "活动",
        "messages": "消息"
    },
    "profile": {
        "returnToList": "返回列表"
    },
    "people": {
        "message": "消息",
        "loadMore": "加载更多",
        "remaining": "剩余",
        "loading": "加载中...",
        "noResults": "没有与您的搜索匹配的结果",
        "studentsAndAlumni": "学生和校友",
        "studentsOnly": "学生",
        "alumniOnly": "校友"
    },
    "filters": {
        "search": "搜索…",
        "citySearch": "搜索城市…",
        "programs": "项目",
        "selectPrograms": "选择项目",
        "all": "全部",
        "students": "学生",
        "alumni": "校友",
        "myClass": "我的班级",
        "showAdvancedFilters": "显示高级筛选条件",
        "quanticDegreePrograms": "Quantic 学位项目",
        "valarDegreePrograms": "Valar 学位项目",
        "execEdPrograms": "高管教育项目",
        "filtersTitle": "筛选条件",
        "applyFilters": "应用筛选",
        "reset": "重置筛选"
    },
    "profileDetail": {
        "backToList": "返回列表",
        "message": "消息",
        "interests": "兴趣",
        "lookingFor": "寻找",
        "education": "教育",
        "workHistory": "工作经历"
    },
    "findMore": {
        "title": "查找更多学生和校友",
        "fromLocation": "来自此位置",
        "workedAtCompany": "曾在此公司工作",
        "fromIndustry": "来自此行业",
        "attendedSchool": "就读于此学校",
        "enrolledInProgram": "参加此项目"
    },
    "advancedFilters": {
        "companySearch": "搜索公司...",
        "industry": "行业",
        "selectIndustry": "选择行业",
        "interests": "兴趣",
        "selectInterest": "选择兴趣",
        "lookingFor": "寻找",
        "selectFromList": "从列表中选择",
        "timezone": "时区",
        "selectTimezones": "选择时区"
    },
    "eventDetail": {
        "event": "活动",
        "backToEvents": "返回活动",
        "details": "详情",
        "register": "注册",
        "addToCalendar": "添加到日历",
        "deviceCalendar": "设备日历",
        "onlineEvent": "线上活动",
        "googleCalendar": "Google Calendar",
        "office365": "Office 365",
        "outlookCom": "Outlook.com",
        "downloadIcs": "下载 (.ics)",
        "detailsAreHidden": "详情仅对在读学生和校友开放。"
    },
    "events": {
        "featured": "精选",
        "upcoming": "即将举行",
        "pastEvents": "过往活动",
        "search": "搜索…",
        "recommendedEvents": "推荐活动",
        "allEvents": "所有活动",
        "searchingAllEvents": "搜索所有活动",
        "noEvents": "未找到活动",
        "noUpcomingEventsMatching": "没有与您的搜索匹配的即将举行的活动",
        "noPastEventsMatching": "没有与您的搜索匹配的过往活动",
        "loadMore": "加载更多",
        "remaining": "剩余",
        "loading": "加载中...",
        "recommendedTooltip": "与您的位置或班级相关的活动",
        "clearFilter": "清除筛选",
        "onlineEvents": "线上活动",
        "inPersonEvents": "线下活动",
        "meetupEvents": "聚会活动",
        "conferenceEvents": "会议活动",
        "companyVisitEvents": "企业参访活动",
        "specialEventEvents": "特别活动",
        "virtualMeetupEvents": "虚拟聚会活动",
        "careerFairEvents": "招聘会活动",
        "admissionsEventEvents": "招生活动",
        "bookClubEvents": "读书会活动",
        "onlineEventEvents": "虚拟聚会活动",
        "documentaryClubEvents": "纪录片俱乐部活动",
        "podcastClubEvents": "播客俱乐部活动",
        "tedTalkClubEvents": "TEDTalk 俱乐部活动",
        "studentOrganizationEventsEvents": "学生组织活动",
        "askMeAnythingEvents": "问答活动",
        "officeHoursEvents": "答疑时间活动",
        "academicWebinarEvents": "学术网络研讨会"
    },
    "contactForm": {
        "title": "给 {name} 发消息",
        "defaultSubject": "{brand} - 来自 {name} 的消息",
        "subject": "主题",
        "replyTo": "回复至",
        "message": "消息",
        "placeholder": "写下您的消息...",
        "send": "发送消息",
        "sending": "发送中...",
        "messageSent": "消息已发送！"
    },
    "cluster": {
        "studentsInArea": "此位置的学生",
        "backToMap": "返回地图"
    },
    "partialAccessModal": {
        "explain": "{brandName} 网络是专为学生和校友打造的全球专属社区。",
        "instructions": "使用地图和筛选条件探索此功能受限的预览版。",
        "deadline": "下一个申请截止日期：",
        "registrationDeadline": "注册截止日期：",
        "applyNow": "立即申请",
        "registerNow": "立即注册",
        "explore": "探索"
    },
    "onboardingWizard": {
        "stepOneTitle": "欢迎来到网络",
        "stepOneMessage": "探索 {brandName} 专属的全球网络。使用地图和筛选条件进行探索。",
        "stepTwoTitle": "浏览社区",
        "stepTwoMessage": "圆圈代表学生和校友群组。点击查看该地区的个人资料。",
        "stepThreeTitle": "自信地建立联系",
        "stepThreeMessage": "通过给同学发消息建立有意义的联系。",
        "stepFourTitle": "发现精彩活动",
        "stepFourMessage": "浏览我们在线上和全球各地举办的专属直播活动。",
        "anonymous": "匿名",
        "hidden": "隐藏",
        "activationTitle": "激活您的个人资料",
        "activationMessageBefore": "您的学生网络个人资料当前设置为",
        "activationMessageAfter": "。您希望让同学们看到您的个人资料吗？",
        "changeSettingSmallprint": "您可以随时在网络设置中更改此偏好。",
        "emailTitle": "首选联系邮箱",
        "emailMessage": "最后一步——请确认您希望用来接收学生和校友消息的邮箱地址！",
        "emailAddress": "邮箱地址",
        "next": "下一步",
        "getStarted": "开始使用",
        "activateMyProfile": "是的！激活我的个人资料",
        "staySetting": "不，保持{setting}",
        "completeSetup": "完成设置"
    },
    "errors": {
        "requestFailed": "请求失败。请检查网络连接后重试。",
        "somethingWentWrong": "出现错误，请重试。",
        "retry": "重试",
        "loadMoreFailed": "加载更多失败，点击重试。",
        "locationPermissionDeniedTitle": "位置权限已关闭",
        "locationPermissionDeniedBody": "请在设备设置中允许访问位置。",
        "locationServicesDisabledTitle": "定位服务已关闭",
        "locationServicesDisabledBody": "请在设备设置中开启定位服务。",
        "locationUnavailableTitle": "无法获取你的位置",
        "locationUnavailableBody": "请重试。"
    }
}
};